"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SWITCH_STAGES = exports.MOVE_OUT_CONFIRM_METER_READ_SUBMIT = exports.MOVE_OUT_CONFIRM_METER_READ_REMINDER = exports.MOVE_OUT_CONFIRM_CANCEL_ERROR = exports.MOVE_OUT_CONFIRM_CANCEL_SUCCESS = exports.MOVE_OUT_CONFIRM_CANCEL_SUBMIT = exports.MOVE_OUT_CONFIRM_CANCEL_LINK = exports.MOVE_OUT_CONFIRM_CHANGE_DATE_ERROR = exports.MOVE_OUT_CONFIRM_CHANGE_DATE_SUCCESS = exports.MOVE_OUT_CONFIRM_DATE_SUBMIT = exports.MOVE_OUT_CONFIRM_CHANGE_DATE = exports.VIEW_INBOUND_SWITCH_TRACKER = exports.CLICK_OMR_SUBMIT = exports.GET_QUOTE = exports.ERRONEOUS_TRANSFER = exports.SWITCHING_MOVE_OUT_LINK = exports.MOVE_OUT_GET_QUOTE = exports.MOVE_OUT_NOT_CANCEL_DD = exports.MOVE_OUT_BACK_BREADCRUMB = exports.MOVE_OUT_CONFIRM_PAGE = exports.MOVE_OUT_CONFIRM = exports.MOVE_OUT = exports.CONTACT_US_LINK = void 0;
exports.CONTACT_US_LINK = 'ContactUsLink';
exports.MOVE_OUT = 'MoveOut';
exports.MOVE_OUT_CONFIRM = 'MoveConfirm';
exports.MOVE_OUT_CONFIRM_PAGE = 'MoveOutConfirm';
exports.MOVE_OUT_BACK_BREADCRUMB = 'MoveOutBackBreadcrumb';
exports.MOVE_OUT_NOT_CANCEL_DD = 'MoveOutNotCancelDD';
exports.MOVE_OUT_GET_QUOTE = 'MoveOutGetQuote';
exports.SWITCHING_MOVE_OUT_LINK = 'SwitchingMoveOutLink';
exports.ERRONEOUS_TRANSFER = 'ErroneousTransfer';
exports.GET_QUOTE = 'GetQuote';
//Inbound switch tracker
exports.CLICK_OMR_SUBMIT = 'SubmitOMR';
exports.VIEW_INBOUND_SWITCH_TRACKER = 'InboundSwitchTracker';
//move out v2
exports.MOVE_OUT_CONFIRM_CHANGE_DATE = 'MoveOutChangeDateCTA';
exports.MOVE_OUT_CONFIRM_DATE_SUBMIT = 'MoveOutChangeDateSubmit';
exports.MOVE_OUT_CONFIRM_CHANGE_DATE_SUCCESS = 'MoveOutChangeDateSuccess';
exports.MOVE_OUT_CONFIRM_CHANGE_DATE_ERROR = 'MoveOutChangeDateError';
exports.MOVE_OUT_CONFIRM_CANCEL_LINK = 'MoveOutCancelLink';
exports.MOVE_OUT_CONFIRM_CANCEL_SUBMIT = 'MoveOutCancelSubmit';
exports.MOVE_OUT_CONFIRM_CANCEL_SUCCESS = 'MoveOutCancelSuccess';
exports.MOVE_OUT_CONFIRM_CANCEL_ERROR = 'MoveOutCancelError';
exports.MOVE_OUT_CONFIRM_METER_READ_REMINDER = 'MoveOutMeterReadReminderCTA';
exports.MOVE_OUT_CONFIRM_METER_READ_SUBMIT = 'MoveOutMeterReadSubmitCTA';
exports.SWITCH_STAGES = {
    REQUESTED: 'requested',
    STARTED: 'started',
    OMR_DUE: 'omr-due',
    OMR_GIVEN: 'omr-given',
    ON_SUPPLY: 'on-supply',
    ERROR: 'unknown',
};
